module.exports = __webpack_public_path__ + "static/img/initial.9af51fd7.png";